



















import { uniqBy } from 'lodash';
import { Component, Vue, Prop } from 'vue-property-decorator';

import Points from './partials/Points.vue';

@Component({
  components: { Points }
})
export default class FutsalPoints extends Vue {
  @Prop() private data!: any;

  get groups(): object {
    const groups: any = [];
    const uniqueGroups = uniqBy(this.data.points, 'group');

    uniqueGroups.forEach((g: any) => {
      const points = this.data.points.filter((p: any) => p.group === g.group);
      groups.push({
        points,
        name: g.group
      });
    });

    return groups;
  }
}
